import logo from "../images/Logo.png";

export const Construction = () => {
  return (
    <section className={"h-screen bg-light-2 dark:bg-dark-2"}>
      <div
        className={
          "flex flex-col items-center justify-center place-self-center pt-6 font-mono"
        }
      >
        <img className={"flex w-1/3"} src={logo} alt={"logo"} />
        <h1
          className={
            "flex text-center text-2xl lg:text-4xl font-bold text-secondary-200 dark:text-primary-500"
          }
        >
          Wisconsin Web Design LLC
        </h1>
        <ul
          className={
            "flex flex-col items-center text-center gap-4 px-6 mt-6 text-sm lg:text-2xl text-secondary-500 dark:text-primary-800"
          }
        >
          <li className={"text-xl lg:text-4xl font-medium"}>
            Under Construction
          </li>
          <li>Our website is still being built.</li>
          <li>If you need to contact us, you can reach out to us at:</li>
          <li>
            <a href="mailto:ryan.alexander.writes.code@gmail.com?Subject=Website">
              ryan.alexander.writes.code@gmail.com
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Construction;
